import Router from 'next/router';

import NotFound from 'Components/NotFound/NotFound';
import useVehicleListButtonConfig from 'Utilities/hooks/vehicleList/useVehicleListButtonConfig';

interface InvalidVehicleProps {
	description?: Nullable<string>;
	title: Nullable<string>;
}

export const InvalidVehicle: React.FC<InvalidVehicleProps> = ({ description, title }) => {
	const { as, href } = useVehicleListButtonConfig();

	return <NotFound description={description} message={title} onClickButton={() => Router.push(href, as)} />;
};
